var m = require('mithril');
var prop = require('mithril/stream');
var dragscroll = require('../../libs/dragscroll');
var pathViewer = require('../../locations/pathViewer');
var serverSidePagination = require('../../data/components/serverSidePagination');
var equipmentModel = require('../models/equipment');

const equipmentOverviewTable = {
  oninit: function(vnode) {
    const ctrl = this;
    ctrl.location = vnode.attrs.location;
    ctrl.equipmentToShow = vnode.attrs.equipment;
    ctrl.preferredNumberOfRowsValue = vnode.attrs.preferredNumberOfRowsValue;
    ctrl.actualPage = [];
    ctrl.searchedEquipmentRids = vnode.attrs.searchedEquipmentRids;
    ctrl.equipmentClassesSelected = vnode.attrs.equipmentClassesSelected;

  },

  onupdate: function(vnode) {
    const ctrl = this;
    const currentLocation = typeof ctrl.location === 'function' ? ctrl.location() : ctrl.location;
    const nextLocation = typeof vnode.attrs.location === 'function' ? vnode.attrs.location() : vnode.attrs.location;
    const currentLocationRid = currentLocation && currentLocation['@rid'];
    const nextLocationRid = nextLocation && nextLocation['@rid'];
    const currentRidsLength = ctrl.searchedEquipmentRids ? ctrl.searchedEquipmentRids().length : 0;
    const nextRidsLength = vnode.attrs.searchedEquipmentRids ? vnode.attrs.searchedEquipmentRids().length : 0;
    // Update properties if vnode attributes have changed
    if (
      currentLocationRid !== nextLocationRid ||
      ctrl.preferredNumberOfRowsValue !== vnode.attrs.preferredNumberOfRowsValue ||
      currentRidsLength !== nextRidsLength
    ) {
      ctrl.location = vnode.attrs.location;
      ctrl.preferredNumberOfRowsValue = vnode.attrs.preferredNumberOfRowsValue;
      ctrl.equipmentToShow = vnode.attrs.equipment;
      ctrl.searchedEquipmentRids = vnode.attrs.searchedEquipmentRids;
      ctrl.equipmentClassesSelected = vnode.attrs.equipmentClassesSelected;
    }
  },
  view: function(vnode) {
    const ctrl = vnode.state;
  
    // Create equipment rows
    const equipmentRows = ctrl.equipmentToShow().map(equipmentRecord => {
      return m('tr', [
        // Location Cell
        createLocationTd(equipmentRecord, ctrl.location, vnode.attrs.equipmentTableLoading),
        // Equipment Category
        createDataTd(
          getEntityCategoryLabel(equipmentRecord),
          vnode.attrs.equipmentTableLoading
        ),
        // Equipment Type
        createDataTd(equipmentRecord['@class'] || '', vnode.attrs.equipmentTableLoading),
      ]);
    });
  
    // Add empty rows to meet preferredNumberOfRowsValue
    const numberOfEmptyRows = Math.max(
      0,
      ctrl.preferredNumberOfRowsValue() - ctrl.equipmentToShow().length
    );
    for (let i = 0; i < numberOfEmptyRows; i++) {
      equipmentRows.push(
        m('tr', [
          createDataTd(undefined, vnode.attrs.equipmentTableLoading), // Empty Location Cell
          createDataTd(undefined, vnode.attrs.equipmentTableLoading), // Empty Equipment Category
          createDataTd(undefined, vnode.attrs.equipmentTableLoading), // Empty Equipment Type
        ])
      );
    }
  
    return m(`div.overflow-hidden.mb3.pt2${vnode.attrs.searchEquipmentActive() ? '' : '.dn'}`, [
      m('div.dragscroll-container', [
        m(
          'div.dragscroll.pb3',
          { oncreate: dragscroll },
          m('table.f4.pb3.narrow.w-100', [
            m('tbody', [
              // Header Row
              m('tr', [
                m(
                  'td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden.nowrap',
                  'Location'
                ),
                m(
                  'td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden',
                  'Category'
                ),
                m(
                  'td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden',
                  'Equipment Type'
                )                
              ]),
              // Equipment Rows and Padding Rows
              equipmentRows,
            ]),
          ]),
          // Conditionally render server-side pagination
          ctrl.searchedEquipmentRids().length > 0 &&
            m(serverSidePagination, {
              data: [...ctrl.searchedEquipmentRids()],
              url: buildEntitySearchUrl(ctrl.equipmentClassesSelected()),
              recordsToShow: ctrl.equipmentToShow,
              parameterFieldName: 'pageNumber',
              searchValue: vnode.attrs.searchEquipmentValue,
              preferredNumberOfRowsValue: ctrl.preferredNumberOfRowsValue,
              locationRid: ctrl.location()['@rid'],
              isLoading: vnode.attrs.equipmentTableLoading
            })
        ),
      ]),
    ]);
  },
};

function createDataTd(content, isLoading) {
  const tdClass = 'bb bl-0 pr1 truncate' + (isLoading() ? ' skeleton' : '');
  const cellContent = isLoading() ? m.trust('&nbsp;') : (content !== undefined ? content : m.trust('&nbsp;'));
  return m('td', { class: tdClass }, cellContent);
}

function createLocationTd(equipmentRecord, parentLocation, isLoading) {
  var recordType = getEntityRecordType(equipmentRecord);
  const tdClass = 'bb bl-0 pr1 nowrap' + (equipmentRecord['$path'] ? ' flex' : '') + (isLoading() ? ' skeleton' : '');
  const cellContent = isLoading()
    ? m.trust('&nbsp;')
    : equipmentRecord['$path']
    ? m(pathViewer, {
        equipmentRecord,
        parentRecord: parentLocation,
        groupByLocation: true,
        recordType: recordType
      })
    : m('label', { style: { visibility: 'hidden' } }, 'No Data');
  return m('td', { class: tdClass }, cellContent);
}

function buildEntitySearchUrl(selectedClasses) {
  var params = new URLSearchParams();
  if (Array.isArray(selectedClasses) && selectedClasses.length) {
    params.set('classes', selectedClasses.join(','));
  } else {
    params.set('families', 'Equipment,Room,Building,Level,Zone');
  }
  params.set('mode', 'paginated');
  return `/api/v1/entities/search?${params.toString()}`;
}

function getEntityCategoryLabel(record) {
  if (!record) return '';
  var className = record['@class'];
  var category = equipmentModel.equipmentClassTree.equipment[className];
  if (category) return category;
  return className ? 'Location' : '';
}

function getEntityRecordType(record) {
  if (!record) return 'equipment';
  var className = record['@class'];
  var equipmentMap = equipmentModel.equipmentClassTree && equipmentModel.equipmentClassTree.equipment;
  if (equipmentMap && equipmentMap[className]) return 'equipment';
  return 'location';
}

module.exports = equipmentOverviewTable;
